// Notification text markup: [texto](url) and bare http(s) URLs become links. Nothing else is
// interpreted and the result is rendered as Vue nodes (never v-html). Only https:, http:,
// mailto: and app paths ("/...") are links; anything else (javascript:, data:...) stays plain
// text. Twin of the backend tokenizer (Notifications::Markup): keep both in sync.
const LINK = /\[([^\]\n]{1,200})\]\(((?:[^()\s]|\([^()\s]*\)){1,2000})\)|https?:\/\/[^\s<>()[\]]+/g;
const TRAILING = /[.,;:!?]+$/;

export function isSafeUrl(url) {
  const u = String(url || "").trim();
  if (!u || u.length > 2000 || /[\s\u0000-\u001f]/.test(u)) return false;
  return /^https?:\/\/[^/\s]+/i.test(u) || /^mailto:[^\s@]+@[^\s@]+$/i.test(u) || /^\/(?![/\\])/.test(u);
}

export function isInternalUrl(url) {
  return String(url || "").startsWith("/");
}

// => [{ text }, { text, url }, ...]
export function tokenize(input) {
  const text = String(input || "");
  const parts = [];
  let pos = 0;
  for (const m of text.matchAll(LINK)) {
    if (m.index > pos) parts.push({ text: text.slice(pos, m.index) });
    if (m[1]) {
      parts.push(isSafeUrl(m[2]) ? { text: m[1], url: m[2] } : { text: m[1] });
    } else {
      const trail = (m[0].match(TRAILING) || [""])[0];
      const url = trail ? m[0].slice(0, -trail.length) : m[0];
      parts.push({ text: url, url });
      if (trail) parts.push({ text: trail });
    }
    pos = m.index + m[0].length;
  }
  if (pos < text.length) parts.push({ text: text.slice(pos) });
  return parts;
}

// At most two buttons, each with a label and a safe URL.
export function cleanActions(actions) {
  return (Array.isArray(actions) ? actions : [])
    .filter((a) => a && String(a.label || "").trim() && isSafeUrl(a.url))
    .slice(0, 2)
    .map((a) => ({ label: String(a.label).trim().slice(0, 40), url: String(a.url).trim() }));
}
